import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { IGotoLoggerMessage, LogCategory, Logger, LoggingService, LoggingServiceConfig } from '@getgo/goto-logger'

import config from 'config'
import { getEnvironment } from 'config/getEnvironment'
import { LS_DEFAULT_COMPONENT, LS_SOURCE, RESTRICTED_LOGGER_KEYS } from './constants'

export const allowedLogCategories: readonly LogCategory[] = ['error', 'warn', 'info', 'log']

let loggingService: LoggingService | null = null

const setUserAgentDetails = (loggingService: LoggingService) => {
  try {
    loggingService.field(RESTRICTED_LOGGER_KEYS.LS_USER_AGENT, window.navigator.userAgent)
    loggingService.field(RESTRICTED_LOGGER_KEYS.LS_LANGUAGE, window.navigator.language)
  } catch (e) {
    console.error('Cannot set userAgent details', e)
  }
}

/* Creates a browser fingerprint which should be unique for each client
 * https://github.com/fingerprintjs/fingerprintjs
 */
const getBrowserFingerprint = async () => {
  try {
    const fp = await FingerprintJS.load()
    const { visitorId } = await fp.get()
    return visitorId
  } catch (e) {
    console.error('Cannot get browser fingerprint')
    return ''
  }
}

export const getLoggingService = async () => {
  if (!loggingService) {
    loggingService = await createLoggingService()
  }

  return loggingService
}

export const createLoggingService = async () => {
  const sessionId = await getBrowserFingerprint()
  const environment = getEnvironment(window.location.hostname)
  const lsConfig: Partial<LoggingServiceConfig> = {
    loggingUrl: config.LOGGING_SERVICE_URL,
    fixed: {
      ls_source: LS_SOURCE,
      env: environment,
      ls_session_id: sessionId,
    },
  }

  const loggingServiceInstance = new LoggingService(lsConfig)
  loggingServiceInstance.field(RESTRICTED_LOGGER_KEYS.LS_COMPONENT, LS_DEFAULT_COMPONENT)
  setUserAgentDetails(loggingServiceInstance)

  return loggingServiceInstance
}

export const attachToLoggerService = (logger: Logger) => {
  allowedLogCategories.forEach((logCategory) => {
    const logHandler = async (message: IGotoLoggerMessage) => {
      try {
        const logMessageWithContext = { ...logger.getContext(), ...message }
        const loggingService = await getLoggingService()
        loggingService.log(logMessageWithContext)
      } catch (e) {
        logger.error(`LoggingService error`, e)
      }
    }

    logger.subscribe(logCategory, logHandler)
  })
}
